import Box from "@mui/material/Box";

import { useI18n } from "@/i18n/I18nProvider";
import { arFont, enFont } from "@/styles/font";

import { MENU_DIVIDER_IMAGE } from "../navbar.config";
import { menuCard } from "../navbar.styles";

/*
 * The white panel every navbar dropdown renders into: a coloured hairline on
 * top and the menu's own content below. Popovers are portalled outside
 * #app-root, so the direction and the font have to be set again here.
 */
export default function MenuCard({
  width,
  dividerImage = MENU_DIVIDER_IMAGE,
  dividerWidth = "100%",
  children,
}) {
  const { locale } = useI18n();

  return (
    <Box
      dir={locale === "en" ? "ltr" : "rtl"}
      sx={{ ...menuCard, width }}
      className={locale === "en" ? enFont.className : arFont.className}
    >
      <Box
        component="img"
        src={dividerImage}
        alt=""
        aria-hidden="true"
        sx={{ width: dividerWidth, height: "5px" }}
      />
      {children}
    </Box>
  );
}
